import React from "react";
import Icon from "@ant-design/icons";

const BidSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 22 22"
    fill="currentColor">
    <path d="M12 20V22H0V20H12ZM12.586 0.686035L20.364 8.46404L18.95 9.88004L17.89 9.52604L15.413 12L21.07 17.657L19.656 19.071L14 13.414L11.596 15.818L11.879 16.95L10.464 18.364L2.686 10.586L4.101 9.17204L5.231 9.45404L11.525 3.16104L11.172 2.10104L12.586 0.686035Z" />
  </svg>
);

const BidIcon = (props) => <Icon component={BidSvg} {...props} />;

export default BidIcon;
